var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorCoupon404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 120,
    viewBox: "0 0 222 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14236_73855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7686 24.8016L71.2725 21.2773",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.584 100.247L83.0879 96.7228",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7814 48.8431L86.2275 41.7261",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.217 64.399L88.6631 57.282",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7141 80.3436L91.1602 73.2266",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7796 8.87577C25.4146 9.55937 22.4301 13.6521 23.1137 18.0172L25.9116 35.8833C27.1492 35.8983 28.361 36.2961 29.3742 37.0349C30.6599 37.9725 31.5206 39.3825 31.7668 40.9546C32.013 42.5267 31.6246 44.1323 30.687 45.4181C29.9482 46.4313 28.916 47.1805 27.7423 47.5731L37.812 111.873C38.4956 116.238 42.5884 119.223 46.9534 118.539L96.3514 110.803C100.716 110.12 103.701 106.027 103.017 101.662L92.9476 37.3616C91.71 37.3466 90.4983 36.9488 89.4851 36.21C88.1993 35.2724 87.3387 33.8625 87.0924 32.2904C86.8462 30.7182 87.2347 29.1127 88.1722 27.8269C88.9111 26.8137 89.9432 26.0645 91.1169 25.6719L88.319 7.80575C87.6354 3.44068 83.5426 0.456244 79.1776 1.13983L29.7796 8.87577ZM44.2411 43.0498C46.4237 42.708 47.9159 40.6616 47.5741 38.4791C47.2323 36.2966 45.1859 34.8043 43.0034 35.1461C40.8209 35.4879 39.3286 37.5343 39.6704 39.7169C40.0122 41.8994 42.0586 43.3916 44.2411 43.0498ZM63.3814 36.0036C63.7232 38.1861 62.231 40.2325 60.0485 40.5743C57.8659 40.9161 55.8196 39.4239 55.4778 37.2414C55.136 35.0588 56.6282 33.0124 58.8107 32.6706C60.9933 32.3288 63.0396 33.8211 63.3814 36.0036ZM79.1888 33.5281C79.5306 35.7106 78.0384 37.757 75.8558 38.0988C73.6733 38.4406 71.6269 36.9484 71.2851 34.7659C70.9433 32.5833 72.4355 30.5369 74.6181 30.1951C76.8006 29.8533 78.847 31.3456 79.1888 33.5281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9116 35.8833L24.9237 36.0381L25.0544 36.873L25.8995 36.8833L25.9116 35.8833ZM29.3742 37.0349L28.785 37.8429L28.785 37.8429L29.3742 37.0349ZM31.7668 40.9546L30.7788 41.1093L31.7668 40.9546ZM30.687 45.4181L29.879 44.8289L29.879 44.8289L30.687 45.4181ZM27.7423 47.5731L27.4251 46.6247L26.6236 46.8928L26.7544 47.7278L27.7423 47.5731ZM37.812 111.873L38.8 111.719L37.812 111.873ZM46.9534 118.539L47.1082 119.527L46.9534 118.539ZM96.3514 110.803L96.1966 109.815L96.3514 110.803ZM103.017 101.662L104.005 101.507L103.017 101.662ZM92.9476 37.3616L93.9355 37.2069L93.8048 36.3719L92.9597 36.3617L92.9476 37.3616ZM91.1169 25.6719L91.4341 26.6202L92.2356 26.3522L92.1049 25.5172L91.1169 25.6719ZM24.1017 17.8625C23.5035 14.043 26.1149 10.4619 29.9344 9.86373L29.6249 7.88782C24.7142 8.65686 21.3567 13.2612 22.1258 18.1719L24.1017 17.8625ZM26.8996 35.7286L24.1017 17.8625L22.1258 18.1719L24.9237 36.0381L26.8996 35.7286ZM29.9633 36.227C28.7812 35.365 27.3675 34.9009 25.9237 34.8834L25.8995 36.8833C26.9308 36.8957 27.9407 37.2273 28.785 37.8429L29.9633 36.227ZM32.7547 40.7999C32.4675 38.9657 31.4634 37.3208 29.9633 36.227L28.785 37.8429C29.8564 38.6243 30.5736 39.7992 30.7788 41.1093L32.7547 40.7999ZM31.495 46.0072C32.5888 44.5072 33.042 42.634 32.7547 40.7999L30.7788 41.1093C30.984 42.4194 30.6603 43.7574 29.879 44.8289L31.495 46.0072ZM28.0595 48.5214C29.4288 48.0634 30.633 47.1893 31.495 46.0072L29.879 44.8289C29.2633 45.6732 28.4032 46.2975 27.4251 46.6247L28.0595 48.5214ZM38.8 111.719L28.7303 47.4183L26.7544 47.7278L36.8241 112.028L38.8 111.719ZM46.7987 117.551C42.9793 118.149 39.3981 115.538 38.8 111.719L36.8241 112.028C37.5931 116.939 42.1974 120.296 47.1082 119.527L46.7987 117.551ZM96.1966 109.815L46.7987 117.551L47.1082 119.527L96.5061 111.791L96.1966 109.815ZM102.029 101.817C102.627 105.636 100.016 109.217 96.1966 109.815L96.5061 111.791C101.417 111.022 104.774 106.418 104.005 101.507L102.029 101.817ZM91.9596 37.5163L102.029 101.817L104.005 101.507L93.9355 37.2069L91.9596 37.5163ZM88.8959 37.018C90.078 37.88 91.4917 38.3441 92.9355 38.3616L92.9597 36.3617C91.9284 36.3492 90.9186 36.0177 90.0743 35.402L88.8959 37.018ZM86.1045 32.4451C86.3917 34.2792 87.3958 35.9242 88.8959 37.018L90.0743 35.402C89.0028 34.6207 88.2856 33.4457 88.0804 32.1356L86.1045 32.4451ZM87.3642 27.2377C86.2704 28.7378 85.8173 30.6109 86.1045 32.4451L88.0804 32.1356C87.8752 30.8255 88.1989 29.4876 88.9802 28.4161L87.3642 27.2377ZM90.7997 24.7235C89.4304 25.1815 88.2262 26.0556 87.3642 27.2377L88.9802 28.4161C89.5959 27.5718 90.456 26.9474 91.4341 26.6202L90.7997 24.7235ZM87.331 7.96047L90.129 25.8266L92.1049 25.5172L89.3069 7.65103L87.331 7.96047ZM79.3323 2.12779C83.1517 1.52965 86.7329 4.14103 87.331 7.96047L89.3069 7.65103C88.5379 2.74032 83.9336 -0.617163 79.0229 0.151876L79.3323 2.12779ZM29.9344 9.86373L79.3323 2.12779L79.0229 0.151876L29.6249 7.88782L29.9344 9.86373ZM46.5861 38.6338C46.8425 40.2707 45.7233 41.8055 44.0864 42.0619L44.3959 44.0378C47.124 43.6105 48.9893 41.0526 48.5621 38.3244L46.5861 38.6338ZM43.1581 36.1341C44.795 35.8778 46.3298 36.9969 46.5861 38.6338L48.5621 38.3244C48.1348 35.5962 45.5769 33.7309 42.8487 34.1582L43.1581 36.1341ZM40.6584 39.5621C40.4021 37.9252 41.5212 36.3905 43.1581 36.1341L42.8487 34.1582C40.1205 34.5854 38.2552 37.1434 38.6825 39.8716L40.6584 39.5621ZM44.0864 42.0619C42.4495 42.3182 40.9147 41.199 40.6584 39.5621L38.6825 39.8716C39.1097 42.5997 41.6677 44.465 44.3959 44.0378L44.0864 42.0619ZM60.2032 41.5623C62.9314 41.135 64.7966 38.5771 64.3694 35.8489L62.3935 36.1583C62.6498 37.7952 61.5307 39.33 59.8938 39.5864L60.2032 41.5623ZM54.4898 37.3961C54.9171 40.1242 57.475 41.9895 60.2032 41.5623L59.8938 39.5864C58.2569 39.8427 56.7221 38.7235 56.4657 37.0866L54.4898 37.3961ZM58.656 31.6827C55.9278 32.1099 54.0626 34.6679 54.4898 37.3961L56.4657 37.0866C56.2094 35.4497 57.3286 33.9149 58.9655 33.6586L58.656 31.6827ZM64.3694 35.8489C63.9422 33.1207 61.3842 31.2554 58.656 31.6827L58.9655 33.6586C60.6024 33.4023 62.1371 34.5214 62.3935 36.1583L64.3694 35.8489ZM76.0105 39.0868C78.7387 38.6595 80.604 36.1016 80.1767 33.3734L78.2008 33.6828C78.4572 35.3197 77.338 36.8545 75.7011 37.1109L76.0105 39.0868ZM70.2972 34.9206C70.7244 37.6487 73.2824 39.514 76.0105 39.0868L75.7011 37.1109C74.0642 37.3672 72.5294 36.248 72.2731 34.6111L70.2972 34.9206ZM74.4634 29.2072C71.7352 29.6344 69.8699 32.1924 70.2972 34.9206L72.2731 34.6111C72.0167 32.9742 73.1359 31.4394 74.7728 31.1831L74.4634 29.2072ZM80.1767 33.3734C79.7495 30.6452 77.1915 28.7799 74.4634 29.2072L74.7728 31.1831C76.4097 30.9268 77.9445 32.0459 78.2008 33.6828L80.1767 33.3734Z",
    fill: "#C7C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4599 75.2489L64.7109 72.2341",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4065 89.1148L86.9248 82.926",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5725 102.946L89.0908 96.7574",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4141 23.8753L59.918 20.3511",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.753,
    y: 77.5212,
    width: 5.2524,
    height: 23.3898,
    transform: "rotate(-60 140.753 77.5212)",
    fill: "white",
    stroke: "#C7C7CC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.339,
    y: 85.3425,
    width: 15.2134,
    height: 54.1693,
    rx: 7.60672,
    transform: "rotate(-60 144.339 85.3425)",
    fill: "#F8F8F8",
    stroke: "#C7C7CC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14236_73855)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108.992,
    cy: 56.1516,
    r: 39.5874,
    transform: "rotate(-60 108.992 56.1516)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.992,
    cy: 56.1516,
    r: 38.5874,
    transform: "rotate(-60 108.992 56.1516)",
    stroke: "#C7C7CC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 108.992,
    cy: 56.1515,
    r: 32.1032,
    transform: "rotate(-60 108.992 56.1515)",
    fill: "#F8F8F8",
    stroke: "#DCAE1D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.268 38.1094L109.268 63.1842",
    stroke: "#DCAE1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.268 73.9072L109.269 73.893",
    stroke: "#DCAE1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14236_73855",
    x: 65.3984,
    y: 13.5576,
    width: 87.1885,
    height: 87.188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14236_73855"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14236_73855",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14236_73855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCoupon404);
export default __webpack_public_path__ + "static/media/error_coupon_404.96d960c92f96e1a62d204f92807c7302.svg";
export { ForwardRef as ReactComponent };